import * as Preact from "preact"

import Index from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/models/juice/Director.js"

import "@frog/source/views/app/screens/CombatEncounterScreen.view.less"

import Stage from "@frog/source/views/app/stage/Stage.view.js"

export default class CombatEncounterScreen {
    render() {
        let stage = Index.game.encounter.stage
        if(Director.steps[0] != undefined
        && Director.steps[0].stage != undefined) {
            stage = Director.steps[0].stage
        }
        // if(Index.game.encounter.selection.hoveredAction != undefined) {
        //     stage = Index.game.encounter.selection.hoveredAction.omegastage
        // }
        return (
            <div class="CombatEncounterScreen">
                <Stage stage={stage}/>
                <HeadsupInterface/>
                <SuccessModal/>
                <FailureModal/>
                <History stage={stage}/>
            </div>
        )
    }
}

// class Background {
//     render() {
//         // <div class="Banner"/>
//         // <div class="Image" style={{"background-image": "url(" + Index.game.encounter.stage.world.image + ")"}}/>
//         return (
//             <div class="Background" style={this.style}/>
//         )
//     }
//     get style() {
//         return {
//         }
//     }
// }

class Objective {
    render() {
        if(Index.game.encounter == undefined
        || Index.game.encounter.slug != "level2") {
            return
        }
        return (
            <div class="Objective" style={this.style}/>
        )
    }
}

////////////////////////
// HEADSUP INTERFACE //
//////////////////////

class HeadsupInterface {
    render() {
        if(window.isToggled == true) return
        return (
            <div class="HeadsupInterface">
                <div class="Buttons">
                    <EndTurnButton/>
                    <UndoButton/>
                    <div class="MenuButton" isActive={true} encounterSlug={Index.game.encounter.slug} onClick={() => Navigation.state.minimenu = {"section": "MainSection"}}><span>X</span></div>
                </div>
            </div>
        )
    }
    // <UnitDetails/>
}

class EndTurnButton {
    render() {
        return (
            <div class="EndTurnButton"
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}
                encounterSlug={Index.game.encounter.slug}
                isActive={this.isActive}>
                <span>End Turn!!</span>
            </div>
        )
    }
    get isActive() {
        return Director.isPerforming != true
    }
    onDown(event) {
        event.stopPropagation()
        Index.game.encounter.endPlayerTurn()
    }
    onUp(event) {
        event.stopPropagation()
    }
}

class UndoButton {
    render() {
        return (
            <div class="UndoButton"
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}
                encounterSlug={Index.game.encounter.slug}
                isActive={this.isActive}>
                <span>Undo!</span>
            </div>
        )
    }
    get isActive() {
        return Index.game.encounter.previousStages.length > 0
    }
    onDown(event) {
        event.stopPropagation()
        Index.game.encounter.undoAction()
    }
    onUp(event) {
        event.stopPropagation()
    }
}

import elements from "@frog/source/data/elements.js"
import Keyset from "@frog/source/utility/Keyset.js"
class UnitDetails {
    render() {
        if(Index.game.encounter.selection.selectedUnit != undefined) {
            const unit = Index.game.encounter.selection.selectedUnit
            if(unit.affiliation == "none") return
            // <div class="Categories">
            //     <div class="Range">{unit.moverange} Move Range</div>
            //     <span>|</span>
            //     <div class="Range">{skills.get(unit.skills[0]).range.max} Attack Range</div>
            // </div>
            return (
                <div class="UnitDetails">
                    <UnitDetailsHeader unit={unit}/>
                    <div class="Effectiveness" element={unit.element}>
                        <div class="Strengths">
                            <span>Strong To:</span>
                            {elements[unit.element].strengths.map((elementKey, index) => {
                                return (
                                    <div class="Element">
                                        <ElementIcon elementKey={elementKey}/>
                                        <span class="Name">{elements[elementKey].name}</span>
                                        {index == 0 ? ", " : undefined}
                                    </div>
                                )
                            })}
                        </div>
                        <div class="Weakenesses">
                            <div class="Label">Weak To:</div>
                            {elements[unit.element].weaknesses.map((elementKey, index) => {
                                return (
                                    <div class="Element">
                                        <ElementIcon elementKey={elementKey}/>
                                        <span class="Name">{elements[elementKey].name}</span>
                                        {index == 0 ? ", " : undefined}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div class="Skills">
                        {unit.skills.map((skillKey) => {
                            const skill = skills.get(skillKey)
                            if(skill == undefined) return
                            const skillView = skillViews[skill.information] || skillViews["generic"]
                            return skillView({unit, skill})
                        })}
                    </div>
                </div>
            )
        }
        if(Index.game.encounter.selection.hoveredUnit != undefined) {
            const unit = Index.game.encounter.selection.hoveredUnit
            if(unit.affiliation == "none") return
            return (
                <div class="UnitDetails">
                    <UnitDetailsHeader unit={unit}/>
                    <div class="Prompt">Click on the unit for more details!</div>
                </div>
            )
        }
    }
}

class UnitDetailsHeader {
    render() {
        const unit = this.props.unit
        return (
            <div class="Header">
                <div class="Identity">
                    <div class="Name">{unit.name}</div>
                    <div class="Sprite" style={{"background-image": "url(" + unit.image + ")"}}/>
                </div>
                <div class="Categories">
                    <div class="Element">
                        <ElementIcon elementKey={unit.element}/>
                        <div class="Name">{elements[unit.element] && elements[unit.element].name}-type</div>
                    </div>
                    <span>|</span>
                    <div class="Level">Level {unit.level}</div>
                </div>
            </div>
        )
    }
}

const skillViews = {
    "strike": function({unit, skill}) {
        return (
            <div class="Skill">
                <div class="Name">Attack</div>
                <div class="Description">
                    Targets enemies [{skill.range.min}] tile{skill.range.min > 1 ? "s" : ""} away.<br/>
                    Deals (2 / 3 / 4) <ElementIcon elementKey={unit.element}/> {unit.element} damage.
                </div>
            </div>
        )
    },
    "none": function() {},
    "generic": function({unit, skill}) {
        return (
            <div class="Skill">
                <div class="Name">{skill.name instanceof Function ? skill.name() : skill.name}</div>
                <div class="Description">
                    {skill.description instanceof Function ? skill.description() : skill.description}
                </div>
            </div>
        )
    }
}

class ElementIcon {
    render() {
        return (
            <div class="ElementIcon" style={{"background-image": "url(" + elements[this.props.elementKey].icon + ")"}}/>
        )
    }
}

class UnitSkills {
    render() {
        return (
            <div class="UnitSkills">
                {this.props.unit.skills.map((skillKey) => (
                    <Skill skillKey={skillKey} unit={this.props.unit}/>
                ))}
            </div>
        )
    }
}

import skills from "@frog/source/data/skills.js"

class Skill {
    render() {
        const skill = skills.get(this.props.skillKey)
        if(skill == undefined) {
            return
        }
        return (
            <div class="Skill"
                canSelect={this.canSelect}
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}>
                {skill.name}
            </div>
        )
    }
    get canSelect() {
        return Index.game.encounter.selection.canSelectUnitSkill(this.props.unit, this.props.skillKey)
    }
    get onDown() {
        return (event) => {
            event.stopPropagation()
            if(Index.game.encounter.selection.selectedSkillKey == undefined) {
                Index.game.encounter.selection.selectedSkillKey = this.props.skillKey
            } else {
                Index.game.encounter.selection.selectedSkillKey = undefined
            }
        }
    }
    onUp(event) {
        event.stopPropagation()
    }
}

/////////////
// MODALS //
///////////

class SuccessModal {
    render() {
        if(Navigation.state.modal == undefined
        || Navigation.state.modal.type != "success") {
            return
        }
        return (
            <div class="SuccessModal" encounterSlug={Index.game.encounter.slug}
                onMouseDown={this.onClick} onTouchStart={this.onClick}>
                <Banner>
                    Cleared!!
                </Banner>
            </div>
        )
    }
    onClick(event) {
        console.log("CoNTINUE")
        Navigation.state.modal.hasClickedContinue = true
    }
}

class Banner {
    render() {
        return (
            <div class="Banner" isActive={true}>
                {this.props.children}
            </div>
        )
    }
}

class ContinueButton {
    render() {
        return (
            <div class="ContinueButton">
                Continue?
            </div>
        )
    }
}

class FailureModal {
    render() {
        if(Navigation.state.modal == undefined
        || Navigation.state.modal.type != "failure") {
            return
        }
        return (
            <div class="FailureModal" encounterSlug={Index.game.encounter.slug}
                onMouseDown={this.onClick} onTouchStart={this.onClick}>
                <Banner>
                    Game Over
                </Banner>
            </div>
        )
    }
    onClick(event) {
        console.log("CoNTINUE")
        Navigation.state.modal.hasClickedContinue = true
    }
}

//////////////
// HISTORY //
////////////

class History {
    render() {
        return (
            <div class="History">
                {this.stages.map((stage) => {
                    if(stage.logs != undefined) {
                        return stage.logs.map((log) => <div class="Log">{log.text}</div>)
                    }
                })}
            </div>
        )
    }
    get stages() {
        return Index.game.encounter.previousStages.concat(this.props.stage)
        // this.props.stage is either Index.game.encounter.stage or Director.steps[0].stage
    }
}

class HistoryStep {
    render() {
        if(this.props.step == undefined) {
            return
        }
        if(this.props.step.type == "move"
        && this.props.step.isStartingMovement == true) {
            return <div>moved</div>
        }
        if(this.props.step.type == "invoke skill") {
            return <div>invoked a skill</div>
        }
    }
}
